import React from 'react'
import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  title: {
    ...typography.body.m,
    fontWeight: typography.fontWeightBold,
    color: palette.grey.shade[100]
  },
  body: {
    ...typography.body.l,
    color: palette.grey.shade[100],
    marginBottom: spacing(4)
  }
}))

const SuspendPanel = ({ suspend }) => {
  const classes = useStyles()
  return (
    <Box data-test='retention-consider-suspend-panel'>
      <Typography className={classes.title}>Before you go</Typography>
      <Typography className={classes.body}>Consider this option:</Typography>
      {suspend}
    </Box>
  )
}

export default SuspendPanel
